import { Auth } from 'aws-amplify';
import { getParameterFromManager } from '../../../services/Utils';
import { createUiLogger } from '../../../logging/uiLogger';
const console = createUiLogger('meaplatform/qaAuthentication');
const AUTH_USER_RETRY_INTERVAL_MS = 1000;
const AUTH_USER_MAX_RETRIES = 3;

export async function getAuthenticatedUserForQA() {
    const validationConfig = await getParameterFromManager("MEA_VALIDATIONS_CHECK");
    const retryEnabled = validationConfig?.default?.auth_user_retry_enabled === true;
    let lastError;

    for (let attempt = 0; attempt <= AUTH_USER_MAX_RETRIES; attempt += 1) {
        try {
            const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
            if (user?.attributes?.email) {
                return user;
            }
            lastError = new Error("Authenticated user email is unavailable.");
        } catch (err) {
            lastError = err;
        }

        if (!retryEnabled || attempt === AUTH_USER_MAX_RETRIES) {
            break;
        }

        const retryDelayMs = AUTH_USER_RETRY_INTERVAL_MS * (2 ** attempt);
        console.warn(
            `Authenticated user lookup attempt ${attempt + 1} failed; retrying in ${retryDelayMs} ms.`,
            lastError?.name,
            lastError?.message
        );
        await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
    }

    throw new Error("Authenticated user email is unavailable. Please retry.", {
        cause: lastError
    });
}
